import {
  CellTemplate,
  Compatible,
  isAlphaNumericKey,
  keyCodes,
  Uncertain,
  UncertainCompatible,
} from "@silevis/reactgrid";
import { ReactNode } from "react";
import { Select } from "antd";
import { Styles } from "./Style";
import { getOptionsFormAppPart } from "@lhd/components/CloneApp/fieldUtils";
import { CellCustomType } from "../../type";
import TextToolTip from "@lhd/components/TextToolTip";
export class MultiChoiceCellTemplate implements CellTemplate<CellCustomType> {
  getCompatibleCell(
    uncertainCell: Uncertain<CellCustomType>,
  ): Compatible<CellCustomType> {
    const uncertainCellAs = uncertainCell as CellCustomType;
    return {
      value: NaN,
      ...uncertainCellAs,
    };
  }

  getClassName(
    cell: Compatible<CellCustomType>,
    isInEditMode: boolean,
  ): string {
    return cell.className || "";
  }

  update(
    cell: Compatible<CellCustomType>,
    cellToMerge: UncertainCompatible<CellCustomType>,
  ): Compatible<CellCustomType> {
    return this.getCompatibleCell({
      ...cell,
      text: cellToMerge.text,
      valueSubmit: cellToMerge.valueSubmit,
    });
  }

  handleKeyDown(
    cell: Compatible<CellCustomType>,
    keyCode: number,
    ctrl: boolean,
    shift: boolean,
    alt: boolean,
  ): { cell: Compatible<CellCustomType>; enableEditMode: boolean } {
    if (!ctrl && !alt && isAlphaNumericKey(keyCode))
      return { cell, enableEditMode: true };
    return {
      cell,
      enableEditMode:
        keyCode === keyCodes.POINTER || keyCode === keyCodes.ENTER,
    };
  }
  render(
    cell: Compatible<CellCustomType>,
    isInEditMode: boolean,
    onCellChanged: (cell: Compatible<CellCustomType>, commit: boolean) => void,
  ): ReactNode {
    if (!isInEditMode) {
      return (
        <div
          style={{
            width: "100%",
            whiteSpace: "pre-wrap",
          }}
        >
          {cell.text}
        </div>
      );
    }
    const options = getOptionsFormAppPart(cell.appPart);
    return (
      <Styles
        onClick={(e) => {
          e.preventDefault();
        }}
        onPointerDown={(e) => e.stopPropagation()}
      >
        <Select
          open
          defaultValue={JSON.parse((cell.valueSubmit as string) || "[]")}
          mode="multiple"
          filterOption={(input, option: any) =>
            option.label.includes(input.trim())
          }
          onChange={(values) => {
            const updatedCell = this.getCompatibleCell({
              ...cell,
              valueSubmit: JSON.stringify(values),
            });

            onCellChanged(updatedCell, false);
          }}
          options={options}
        />
      </Styles>
    );
  }
}
